// extracted by mini-css-extract-plugin
module.exports = {"hoverlessContainer":"style_hoverlessContainer__tz-5Q","content":"style_content__2Whhv"};